import type {ParamsProps} from '@/components/WdiBus/FormPage';
import {ResponseStatus} from '@/utils/request';
import type {WdiModalAppResult} from '@/components/WdiControls';
import {wdiCore} from '@/components/WdiControls';
import {FormApi} from '@/services/sales';
import {FormSa, FormSaDetail} from '@/services/sales/sa';
import {EC} from '@/services/mdm/ec';
import {Enum} from '@/enums/system';
import {BudgetProject} from '@/services/sales/bp/budgetProject';
import {Product} from '@/services/mdm/product';
import {getSalesAndCostRegionOptions, getSalesAndCostSoldToOptions} from "@/pages/sales/sa/components/SalesAndCost";

export type ViewEntityProps = {
  budgetProject?: API.BudgetProject;
  form?: API.Form;
  formSa?: API.FormSa;
  formBudgetProject?: API.FormBudgetProject;
  relationType?: number;
  relatedFormId?: number;
  formId?: number;
  statusId?: number;
  formTypeId?: number;
  pageTypeId?: number;
  bohqId?: number;
  budgetProjectId?: number;
  userId?: number;
  positionId?: number;
  ecId?: number;
  ecFieldConfigs?: API.EcFieldConfig[];
  // 随货使用
  revenueType?: number;
  // 销量与费用客户
  boLevelSoldToOpts?:any[],
  // 销量与费用区域
  boLevelRegionOpts?:any[],
};

export const initApplyPageContext = async (params: ParamsProps) => {

  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };

  const viewEntity: ViewEntityProps = {};

  viewEntity.formTypeId = params.formTypeId;
  viewEntity.pageTypeId = params.pageTypeId;
  viewEntity.budgetProjectId = params.budgetProjectId;
  // viewEntity.bohqId = params.bohqId;
  viewEntity.userId = params.userId;
  viewEntity.positionId = params.positionId;
  // 随货使用
  viewEntity.revenueType = params.revenueType;
  if (params.formId) {
    //草稿
    const form = await FormApi.get(params.formId);
    viewEntity.form = form.data;
    const formSa = await FormSa.get(params.formId);
    viewEntity.formSa = formSa.data;
    viewEntity.statusId = viewEntity.form.statusId;
    viewEntity.formId = viewEntity.form.formId;
    //viewEntity.bohqId = formSa.data.bohqId;
  } else if (params.relatedFormId) {
    //变更
    const form = await FormApi.get(params.relatedFormId);
    viewEntity.form = form.data;
    viewEntity.relatedFormId = viewEntity.form.formId;
    viewEntity.relationType = params.relationType;


    const formSa = await FormSa.get(params.relatedFormId);
    viewEntity.formSa = formSa.data;
    if (formSa.data.budgetProjectId) {
      const budgetProjectResponse = await BudgetProject.get(formSa.data.budgetProjectId ?? 0);
      viewEntity.budgetProject = budgetProjectResponse.data;
      if (!viewEntity.budgetProject) {
        result.message = "无效的专项项目";
        return result;
      }
    }

    if (viewEntity.relationType == Enum.FormRelationType.REJECTED && viewEntity.form.statusId != Enum.FormStatus.REJECTED) {
      result.message = viewEntity.form.formNo + "单据不是退回待修改状态，无效的操作！";
      return result;
    }
    if (viewEntity.relationType == Enum.FormRelationType.MODIFIED && viewEntity.form.statusId != Enum.FormStatus.APPROVE_COMPLETED) {
      result.message = viewEntity.form.formNo + "单据不是审批完成状态，无效的操作！";
      return result;
    }
  }

  if (viewEntity.form) {
    if (!params.budgetProjectId && viewEntity.formSa && viewEntity.formSa.budgetProjectId) {
      viewEntity.budgetProjectId = viewEntity.formSa.budgetProjectId;
    }
    if (!params.formTypeId) {
      viewEntity.formTypeId = viewEntity.form.formTypeId;
    }
    if (!params.pageTypeId) {
      viewEntity.pageTypeId = viewEntity.form.pageTypeId;
    }
    if (!params.userId) {
      viewEntity.userId = viewEntity.form.userId;
    }
    if (!params.positionId) {
      viewEntity.positionId = viewEntity.form.positionId;
    }
    // 随货使用
    if (!params.revenueType) {
      const formSaDetailResp = await FormSaDetail.getTop1FormSaDetail(viewEntity.form.formId);
      viewEntity.revenueType = formSaDetailResp.data?.revenueType;
    }
  }

  // //后补类活动需要费用项扩展列
  if (viewEntity.pageTypeId === Enum.PageType.ACTIVITY_APPLICATION) {
    const ecFieldConfigsResponse = await EC.getEcFieldConfigs();
    viewEntity.ecFieldConfigs = ecFieldConfigsResponse.data;
  }

  if (params.budgetProjectId) {
    const budgetProjectResponse = await BudgetProject.get(params.budgetProjectId);
    viewEntity.budgetProject = budgetProjectResponse.data;
    if (!viewEntity.budgetProject) {
      result.message = "无效的专项项目";
      return result;
    }
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
}

export const initApprovalPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId) {
    const formSAResponse = await FormSa.get(params.formId);
    viewEntity.formSa = formSAResponse.data;
    if (!viewEntity.formSa) {
      result.message = "无效的草稿单";
      return result;
    }

    const formResponse = await FormApi.get(params.formId);
    viewEntity.form = formResponse.data;

    if (viewEntity.formSa.budgetProjectId) {
      const budgetProjectResponse = await BudgetProject.get(viewEntity.formSa.budgetProjectId);
      viewEntity.budgetProject = budgetProjectResponse.data;
    }
    //后补类活动需要费用项扩展列
    if (viewEntity.formSa.pageTypeId === Enum.PageType.ACTIVITY_APPLICATION) {
      const ecFieldConfigsResponse = await EC.getEcFieldConfigs();
      viewEntity.ecFieldConfigs = ecFieldConfigsResponse.data;
    }
    if (viewEntity.formSa.pageTypeId !== Enum.PageType.PRICE_DISCOUNT_APPLICATION) {
      viewEntity.boLevelSoldToOpts = await getSalesAndCostSoldToOptions();
    }
    viewEntity.boLevelRegionOpts = await getSalesAndCostRegionOptions();
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
}

export const getFormStatusName = async (entity: ViewEntityProps) => {
  if (entity.form?.statusId === Enum.FormStatus.APPROVE_COMPLETED) {
    if (entity.formSa?.isClosed) {
      return '已审批已关闭';
    } else {
      if (entity.formSa?.settlementMode === 1 || entity.formSa?.settlementMode === 2) {
        if (entity.formSa.settledStatus === 2) {
          return '已审批已结案';
        } else if (entity.formSa.settledStatus === 1) {
          return '已审批结案中';
        } else {
          return '已审批未结案';
        }
      } else {
        return '已审批未关闭';
      }
    }
  } else {
    let formStatusName = "";
    switch (entity.formSa?.statusId) {
      case 0:
        formStatusName = '草稿';
        break;
      case 1:
        formStatusName = '待审批';
        break;
      case 2:
        formStatusName = '已审批';
        break;
      case 3:
        formStatusName = '退回待修改';
        break;
      case 4:
        formStatusName = '作废';
        break;
    }
    return formStatusName;
  }
}

export const getDetailPrevData = (formSaDetail: API.FormSaDetail) => {
  return {
    ecId: formSaDetail.ecId,
    soldToCode: formSaDetail.soldToCode,
    custSysCode: formSaDetail.custSysCode,
    boId: formSaDetail.boId,
    revenueType: formSaDetail.revenueType,
    formSaDetailIdOriginal: formSaDetail.formSaDetailIdOriginal,
    sfaResultDesc: formSaDetail.sfaResultDesc,
    sfaShopQuantity: formSaDetail.sfaShopQuantity,
    sfaAmount: formSaDetail.sfaAmount,
  };
};

export const paymentMethodDataLoading = async (ecId: number) => {
  const results = await Promise.all([EC.getPaymentMethods(ecId)]);
  if (results[0]) {
    const paymentMethodRes = results[0];
    return paymentMethodRes.data;
  }
  return [];
};

/**
 默认列：四级使用部门，客户，门店，产品别，费用项，核算类型，支付方式，申请金额
 <br />扩展列：一级~三级使用部门，费用大类，费用小类，是否同步到SFA，预计费比，备注，货补池产品别，活动开始日期，活动截止日期，开始供货日期，
 截止供货日期，单位，原供货价，促销供货价，原零售价，促销零售价，单位补差金额，预计出货销量，达标销量，预计出货销售额，达标销售额，预计POS销量，
 预计POS销售额，转化率，活动主题，陈列形式，陈列数量，陈列面积，活动明细编号（活动单号-明细id），实际出货销量，实际出货销售额，实际POS销量，实际POS销售额，实际费比
 <br />备注后的字段都是如果有值就显示，没有值再根据费用项+核销类型的申请所需内容的字段配置显示；产品别取ProductBuyNames字段既可
 */
const allExtensionsColumns = [
  'shipToCode',
  'productFgIds',
  'activityStartDate',
  'activityEndDate',
  'supplyStartDate',
  'supplyEndDate',
  'priceSellinBefore',
  'priceSellinAfter',
  'priceSellinBeforeMin',
  'priceSellinAfterMin',
  'pricePosBefore',
  'pricePosAfter',
  'unitExpense',
  'quantitySellinForecast',
  'quantityTarget',
  'revenueSellinForecast',
  'revenueTarget',
  'quantityPosForecast',
  'revenuePosForecast',
  'executionRateForecast',
  'activitySubjectId',
  'displayTypeIds',
  'displayQuantity',
  'displayArea',
  'tpmDetailId',
  'productBuyCodes',
  'quantitySellinActual',
  'revenueSellinActual',
  'quantityPosActual',
  'revenuePosActual',
  'roiActual',
  'sfaResultDesc',
  'sfaShopQuantity',
  'unitExpenseSoldTo',
  'targetShopQuantity',
  'modifiedUserId',
  'modifiedReason',
  'grossRate',
  "priceLimit",
  "priceLimitBelowRate",
  "ip",
  'formSaDetailIdOriginal', // 新增：原活动明细ID
  'sfaAmount',              // 新增：SFA执行金额
];

export const getAllHasValueColumns = (record: any) => {
  const hasValueColumns: string[] = [];
  for (const column of allExtensionsColumns) {
    if (!wdiCore.Object.IsNullOrUndefined(record[column])) {
      hasValueColumns.push(column);
    }
  }
  return hasValueColumns;
};

export const getActivityStatus = (record?: any, formStatusOptions?: API.DataOptions[]) => {
  if (!record) return;
  if (record.statusId === 2) {
    if (record.isClosed) {
      return "已审批已关闭";
    }
    return "已审批未关闭";
  }
  const formStatus = (formStatusOptions ?? []).find(item => record.statusId == item.value);
  return formStatus?.name;
}

export const freeGoodsProductAjaxDataLoading = async (params: API.ProductSearchParam) => {
  const responseResult = await Product.ajaxSearchNoRoot(params);
  return responseResult.data?.map((item: any) => {
    return {value: item.productId, label: item.codeOrName};
  });
}

export const freeGoodsProductDataLoading = async (params: API.ProductSearchParam) => {
  const responseResult = await Product.searchNoRoot(params);
  return responseResult.data?.map((item: any) => {
    return {value: item.productId, label: item.codeOrName};
  });
}

export const getProductSheet = () => {
  return {
    dataLoading: async () => {
      return await Product.queryForSheet({
        isActive: true,
        productLevel: Enum.ProductLevel.PRODUCT5
      });
    },
    data: null,
    names: [
      {name: "productCode5", displayName: "产品编号"},
      {name: "productName5", displayName: "产品名称"},
      {name: "productCode4", displayName: "V码规格编号"},
      {name: "productName4", displayName: "V码规格名称"},
      {name: "productCode3", displayName: "销售小类编号"},
      {name: "productName3", displayName: "销售小类名称"},
      {name: "productCode2", displayName: "销售大类编号"},
      {name: "productName2", displayName: "销售大类名称"},
      {name: "productCode1", displayName: "品牌编号"},
      {name: "productName1", displayName: "品牌名称"},
      {name: "vCode", displayName: "V码"},
      {name: "specCode", displayName: "规格编号"},
      {name: "specName", displayName: "规格名称"},
      {name: "uom", displayName: "主单位名称"},
      {name: "uom1", displayName: "包装1单位名称"},
      {name: "uom1Quantity", displayName: "包装1数量"},
      {name: "uom2", displayName: "包装2单位名称"},
      {name: "uom2Quantity", displayName: "包装2数量"},
      {name: "weightNet", displayName: "净重"},
      {name: "companyCodeOrNames", displayName: "公司"},
    ],
    sheetName: "产品",
  }
}

export const getSaLink = (item: API.FormSa) => {
  if (Enum.PageType.ACTIVITY_APPLICATION == item.pageTypeId) {
    return '/sales/sa/GeneralActivityApproval';
  }
  if (Enum.PageType.PRICE_DISCOUNT_APPLICATION == item.pageTypeId) {
    return '/sales/sa/PriceDiscountApproval/';
  }
  if (Enum.PageType.FREE_GOODS_APPLICATION == item.pageTypeId) {
    return '/sales/sa/GeneralActivityApproval';
  }

  if (Enum.PageType.MKT_APPLICATION == item.pageTypeId) {
    return '/mkt/sa/mktapproval';
  }
  return '';
};

export const soldToRealLoadingResultFormat = (
  promise: Promise<API.ResponseResult<API.SoldToReal[]>>,
) => {
  return promise.then((response) => {
    return (response.data ?? []).map((item) => ({
      code: item.soldToRealCode,
      name: item.soldToRealName,
      value: item.soldToRealCode,
      label: item.codeOrName,
    }));
  });
};

export const shipToLoadingResultFormat = (promise: Promise<API.ResponseResult<API.ShipTo[]>>) => {
  return promise.then((response) => {
    return (response.data ?? []).map((item) => ({
      code: item.shipToCode,
      name: item.shipToName,
      value: item.shipToCode,
      label: item.codeOrName,
    }));
  });
};

